<div class="container-fluid mt-3 mb-3 theme">
    <div class="row nowrap mt-4 mb-3" aria-label="breadcrumb">
        <div class="col-lg-10">
            <div class="d-flex usercontrol">
                <h1>{{action=='add'?'Add User':'Edit User'}}</h1>
                <ul class="breadcrumbcustom" role="navigation" aria-labelledby="breadcrumb">
                    <li><a routerLink="">Home</a></li>
                    <li><a routerLink="/admin/userList" skipLocationChange>User Management</a></li>
                    <li class="active"><a routerLink="/admin/userList/add-user" skipLocationChange
                            aria-current="page">{{action=='add'?'Add User':'Edit User'}}</a></li>
                </ul>
            </div>
        </div>
    </div>
    <div class="card card-body colorborder">
        <form [formGroup]='adduserForm' (ngSubmit)="onSubmit()">
            <div class="row">
                <div class="col-lg-3 form-group">
                    <label>Login ID<span class="red">*</span> </label>
                    <input type="text" value="" class="form-control form-control-sm" formControlName="userLoginId"
                        placeholder="Enter Login ID">
                    <div *ngIf="f.userLoginId.invalid && f.userLoginId.touched">
                        <p *ngIf="f.userLoginId.errors.required" class="error nocase">
                            Please enter login ID
                        </p>
                        <p *ngIf="f.userLoginId.errors.pattern" class="error nocase">
                            Login ID should start with alphanumeric character. It should contain at least 5
                            characters & should not contain any white spaces.
                        </p>
                    </div>
                </div>
                <div class="col-lg-3 form-group">
                    <label>Entity Type<span class="red">*</span> </label>
                    <select class="form-control form-control-sm selectpicker" formControlName="entityType"
                        (change)="selectEntityType()" title="Select Entity Type">
                        <option *ngFor="let data of entityTypeData" value="{{data.entityType}}">{{data.entityType}}
                        </option>
                    </select>
                    <p *ngIf="submitted && !f.entityType.value" class="error nocase">
                        Please enter entity type
                    </p>
                </div>
                <div class="col-lg-3 form-group">
                    <label>Entity Code<span class="red">*</span> </label>
                    <select class="form-control form-control-sm selectpicker" formControlName="entityCode" data-live-search="true"
                        title="Select Entity Code" (change)="selectEntityCode()">
                        <option *ngFor="let data of entityCodeData" value="{{data.entityCode}}">{{data.entityCode
                            +'-'+ (data.userName||'')}}</option>
                    </select>
                    <p *ngIf="submitted && !f.entityCode.value" class="error nocase">
                        Please enter entity code
                    </p>
                </div>
                <div class="col-lg-3 form-group">
                    <label>User Name<span class="red">*</span> </label>
                    <input type="text" value="" class="form-control form-control-sm" formControlName="userName">
                    <div *ngIf="f.userName.invalid && f.userName.touched" class="error nocase">
                        Please enter user name
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-3 form-group">
                    <label>Email ID<span class="red">*</span> </label>
                    <input type="email" value="" class="form-control form-control-sm" formControlName="userEmail" email
                        placeholder="Enter Email Address">
                    <div *ngIf="f.userEmail.invalid && f.userEmail.touched">
                        <p *ngIf="f.userEmail.errors.required" class="error nocase">
                            Please enter email ID
                        </p>
                        <p *ngIf="f.userEmail.errors.email" class="error nocase">
                            Please enter valid email ID
                        </p>
                    </div>
                </div>
                <div class="col-lg-3 form-group">
                    <label>Mobile Number<span class="red">*</span> </label>
                    <input type="text" value="" class="form-control form-control-sm" formControlName="userMobile"
                        placeholder="Enter Mobile Number">
                    <div *ngIf="f.userMobile.invalid && f.userMobile.touched">
                        <p *ngIf="f.userMobile.errors.required" class="error nocase">
                            Please enter mobile number
                        </p>
                        <p *ngIf="f.userMobile.errors.pattern" class="error nocase">
                            Please enter valid mobile number
                        </p>
                    </div>
                </div>
                <div class="col-lg-3 form-group">
                    <label>User Type<span class="red">*</span> </label>
                    <select class="form-control form-control-sm" formControlName="userType" data-style="btn-info"
                        title="Select User Type" [attr.disabled]="(action=='view')?'':null">
                        <option *ngFor="let type of userTypeData" value='{{type.id}}'>{{type.name}}</option>
                    </select>
                    <p *ngIf="f.userType.invalid && f.userType.touched" class="error nocase">
                        Please select user type
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-3 form-group">
                    <label>Status<span class="red">*</span> </label>
                    <select class="form-control form-control-sm" formControlName="isActive" data-style="btn-info"
                        [attr.disabled]="(action=='view')?'':null">
                        <option value='Y'>Active</option>
                        <option value='N'>Deactive</option>
                    </select>
                    <p *ngIf="f.isActive.invalid && f.isActive.touched" class="error nocase">
                        Status is required
                    </p>
                </div>
                <div class="col-lg-3 form-group" *ngIf="user.comments">
                    <label>Comments</label>
                    <input type="text" class="form-control form-control-sm" formControlName="comments" disabled>
                </div>
                <div class="col-lg-3 form-group" *ngIf="action=='update'">
                    <label>Is deleted </label>
                    <select class="form-control form-control-sm" formControlName="isDeleted" data-style="btn-info">
                        <option value='Y'>Yes</option>
                        <option value='N'>No</option>
                    </select>
                    <p *ngIf="f.isDeleted.invalid && f.isDeleted.touched" class="error nocase">
                        Is deleted is required
                    </p>
                </div>

            </div>
            <div class="row">
                <div class="col-lg-3 form-group" *ngIf="user.createdByString">
                    <label>Created by </label>
                    <p>{{user.createdByString}} on {{user.createdDate|date:"medium"}}</p>
                </div>
                <div class="col-lg-3 form-group" *ngIf="user.updatedByString">
                    <label>Last modified by </label>
                    <p>{{user.updatedByString}} on {{user.lastModifiedOn|date:"medium"}}</p>
                </div>
                <div class="col-lg-3 form-group" *ngIf="user.checkedByString">
                    <label>Verified by </label>
                    <p>{{user.checkedByString}} on {{user.checkedDate|date:"medium"}}</p>
                </div>
                <div class="col-lg-3 form-group" *ngIf="user.deactivationDate">
                    <label>Deactivation Date </label>
                    <p>{{user.deactivationDate|date:"medium"}}</p>
                </div>
            </div>
            <div class="row justify-content-start mb-5">
                <div class="col-lg-8">
                    <div class="row justify-content-start">
                        <div class="col-lg-2 usercontrol"> <!--*ngIf="access.roleId==1"-->
                            <button class="btn btn-primary full-width"
                                [disabled]="adduserForm.invalid || !!(action=='view') || submitted">Submit</button>
                        </div>
                        <div class="col-lg-2">
                            <button class="btn btn-cancel full-width" type="button" routerLink="../"
                                skipLocationChange>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
